import { makeStyles } from '@material-ui/core';
import theme from '../../../../theme/MyEirTheme';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const styles = makeStyles(() => ({
    helpCentreContainer: {
        maxWidth: '995px',
        margin: 'auto',
    },
    mobileIcon: {
        width: '1.875rem',
    },
    card: {
        borderRadius: '6px',
        background: theme?.palette.primary?.white,
        boxShadow: 'none',
        filter:
            'drop-shadow(0px 5.97857px 5.97857px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.98571px 13.95px rgba(0, 0, 0, 0.07)) drop-shadow(0px 3.98571px 17.9357px rgba(0, 0, 0, 0.12))',
        '& .title': {
            paddingTop: '1rem',
            color: theme?.palette?.primary?.heather,
        },
        '&.MuiCard-root': {
            overflow: 'unset !important',
            flexGrow: '1',
        },
    },
    cardInfo: {
        padding: '1.5rem 1.5rem 1rem 1.5rem',
    },
    serviceDetails: {
        paddingBottom: '15px',
        '& .link': {
            width: 'fit-content',
            display: 'flex',
            margin: 'auto',
            color: theme?.palette?.primary?.sunset,
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    mobileContainer: {
        marginTop: '2rem',
    },
    desktopContainer: {
        marginTop: '3.2rem',
    },
    accordionDetails: {
        paddingBottom: '0.75rem',
    },

    accordionBox: {
        '& .accordion-title': {
            paddingLeft: '1.875rem',
            color: theme?.palette?.primary?.heather,
        },
        paddingBottom: '1rem',
        '& .MuiIconButton-edgeEnd': {
            marginRight: '0.375rem',
        },
        '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            paddingLeft: '2rem',
        },
        '& .MuiAccordionDetails-root': {
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: '12px 16px 6px 16px',
        },
        '& .MuiAccordionSummary-root.Mui-expanded': {
            borderRadius: '0.375rem',
            boxShadow: `0px 6px 6px -3px ${theme?.palette?.primary?.boxShadow2Dark}, 0px 10px 14px 1px ${theme?.palette?.primary?.boxShadow2Medium}, 0px 4px 18px 3px ${theme?.palette?.primary?.boxShadow2Lite}`,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0,
        },
        '& .help-expand-icon': {
            width: '36px',
            height: '36px',
            color: theme.palette.primary.sunset,
        },
        '& .MuiPaper-root.MuiAccordion-root.MuiAccordion-rounded': {
            borderRadius: '0.375rem',
            boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
        },
        '& .link': {
            width: 'fit-content',
            display: 'flex',
            margin: 'auto',
            color: theme?.palette?.primary?.heather,
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
}));

export default styles;
